<div formGroupName="contModInputChildForm">
  <h2>契約情報</h2>

  <div *ngIf="dispPrdClsfyDiv === 'basiCtr' || dispPrdClsfyDiv === 'oguchi' || dispPrdClsfyDiv === 'ather'">
    <div *ngIf="dispPrdClsfyDiv !== 'ather'"
      class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
      <mat-form-field appearance="outline"
        class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
        <mat-label>契約担当部署</mat-label>
        <mat-select formControlName="contractDepartmentCategory" (selectionChange)="onChangeSelectBox($event)">
          <mat-option *ngFor="let contractDepartment of contractDepartmentList" [value]="contractDepartment.value">
            {{contractDepartment.viewValue}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline"
        class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
        <mat-label>契約担当者</mat-label>
        <mat-select formControlName="contractManagerCategory">
          <mat-option *ngFor="let contractManager of contractManagerList" [value]="contractManager.value">
            {{contractManager.viewValue}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div *ngIf="dispPrdClsfyDiv !== 'ather'"
      class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
      <mat-form-field appearance="outline"
        class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
        <mat-label>お客さま担当部署</mat-label>
        <input matInput formControlName="customerDepartment" autocomplete="off" maxlength="50">
      </mat-form-field>

      <mat-form-field appearance="outline"
        class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
        <mat-label>お客さま担当者</mat-label>
        <input matInput formControlName="customerManager" autocomplete="off" maxlength="50">
      </mat-form-field>
    </div>

    <div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
      <mat-form-field appearance="outline"
        class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
        <mat-label>契約開始日</mat-label>
        <input matInput [matDatepicker]="appliStartDate" formControlName="appliStartDate" autocomplete="off" required>
        <mat-datepicker-toggle matSuffix [for]="appliStartDate"></mat-datepicker-toggle>
        <mat-datepicker #appliStartDate></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="outline"
        class="month-style input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
        <mat-label>初回検針年月</mat-label>
        <input matInput formControlName="firstMeterReadMon" autocomplete="off" maxlength="7" type="month" required>
      </mat-form-field>

      <mat-form-field appearance="fill" *ngIf="dispPrdClsfyDiv !== 'ather'"
        class="input-form-select tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[25%]">
        <mat-label>契約満了年月</mat-label>
        <input matInput readonly="true" formControlName="expirationMon" class="font-color-display-only" maxlength="7"
          required />
      </mat-form-field>
    </div>
  </div>

  <div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
    <mat-form-field appearance="fill"
      class="input-form-select tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
      <mat-label>契約終了日</mat-label>
      <input matInput readonly="true" [matDatepicker]="appliEndDate" formControlName="appliEndDate"
        class="font-color-display-only" />
      <mat-datepicker #appliEndDate></mat-datepicker>
    </mat-form-field>

    <mat-form-field appearance="outline"
      class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
      <mat-label>独自管理対象個別コード</mat-label>
      <input matInput formControlName="IndManageSign" autocomplete="off" maxlength="5">
    </mat-form-field>
  </div>

  <div *ngIf="dispSrvClsfyCode === 'gas'">
    <div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
      <mat-form-field appearance="outline"
        class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[25%]">
        <mat-label>冷房能力</mat-label>
        <input matInput formControlName="coolAbility" autocomplete="off" class="number-style"
          (blur)="onBlurNumberComma('coolAbility')" (focus)="onFocusNumberComma('coolAbility')"
          [maxlength]="numberCommaMaxLength1">
        <span matSuffix class="tw-ml-[5px]">kW</span>
      </mat-form-field>

      <mat-form-field appearance="outline"
        class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[25%]">
        <mat-label>発電容量</mat-label>
        <input matInput formControlName="generatCapacity" autocomplete="off" class="number-style"
          (blur)="onBlurNumberComma('generatCapacity')" (focus)="onFocusNumberComma('generatCapacity')"
          [maxlength]="numberCommaMaxLength2">
        <span matSuffix class="tw-ml-[5px]">kW</span>
      </mat-form-field>

      <mat-form-field appearance="outline"
        class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[25%]">
        <mat-label>定格入力値（合計）</mat-label>
        <input matInput formControlName="preRatedInputValue" autocomplete="off" class="number-style"
          (blur)="onBlurNumberComma('preRatedInputValue')" (focus)="onFocusNumberComma('preRatedInputValue')"
          [maxlength]="numberCommaMaxLength3">
        <span matSuffix class="tw-ml-[5px]">kW</span>
      </mat-form-field>

      <mat-checkbox id="airControlFlg" formControlName="airControlFlg" *ngIf="dispPrdClsfyDivGas === 'on'"
        class="check-box tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[5%] tw-ml-[40px]"
        color="primary">空調
      </mat-checkbox>

      <mat-checkbox id="deviceFlg" formControlName="deviceFlg" *ngIf="dispPrdClsfyDivGas === 'on'"
        class="check-box tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[5%] tw-ml-[40px]"
        color="primary">機器定格
      </mat-checkbox>
    </div>
  </div>

  <div *ngIf="dispSrvClsfyCode === 'electric' || dispSrvClsfyCode === 'gas'">
    <div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
      <mat-form-field appearance="outline" *ngIf="dispSrvClsfyCode === 'electric'"
        class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
        <mat-label>停止時要配慮フラグ</mat-label>
        <mat-select formControlName="attentionOnStopFlagCategory" required>
          <mat-option *ngFor="let attentionOnStopFlag of attentionOnStopFlagList" [value]="attentionOnStopFlag.value">
            {{attentionOnStopFlag.viewValue}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-checkbox id="noticeOfAdjustmentUnitChargeIssueFlg" formControlName="noticeOfAdjustmentUnitChargeIssueFlg"
        class="check-box tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[5%] tw-ml-[40px] set-bottm"
        color="primary">調整単位料金おしらせ発行フラグ
      </mat-checkbox>
    </div>
  </div>

  <div *ngIf="dispSrvClsfyCode === 'electric'">
    <div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
      <mat-form-field appearance="outline"
        class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
        <mat-label>関連会社区分</mat-label>
        <mat-select formControlName="kanrengaisyaCategory">
          <mat-option *ngFor="let kanrengaisya of kanrengaisyaList" [value]="kanrengaisya.value">
            {{kanrengaisya.viewValue}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline"
        class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
        <mat-label>関連会社お客さま番号</mat-label>
        <input matInput formControlName="kanrengaisyaOkyakusamaNo" autocomplete="off" maxlength="20" />
      </mat-form-field>
    </div>
  </div>

  <!-- 契約お客さま番号 -->
  <input formControlName="firstSrvctrNo" autocomplete="off" type="hidden" />
  <!-- サービス契約番号 -->
  <input formControlName="srvCtrNo" autocomplete="off" type="hidden" />
  <!-- 更新通番号 -->
  <input formControlName="updateSrno" autocomplete="off" type="hidden" />

  <div *ngIf="dispFtiGoods === true">
    <h2>付帯契約情報</h2>
    <div formArrayName="items">
      <ng-container *ngFor="let item of items.controls; let i = index" [formGroupName]="i">
        <div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
          <mat-form-field appearance="fill"
            class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[25%] tw-lg:max-w-[full]">
            <mat-label>付帯商品コード</mat-label>
            <input matInput readonly="true" formControlName="ftGoodsName" autocomplete="off"
              class="font-color-display-only" />
          </mat-form-field>

          <mat-form-field *ngIf="item.get('dispChokiItem').value === true" appearance="outline"
            class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[20%]">
            <mat-label>適用開始日</mat-label>
            <input matInput [matDatepicker]="opeStartMonth" formControlName="opeStartMonth" autocomplete="off" required>
            <mat-datepicker-toggle matSuffix [for]="opeStartMonth"></mat-datepicker-toggle>
            <mat-datepicker #opeStartMonth></mat-datepicker>
          </mat-form-field>

          <mat-form-field *ngIf="item.get('dispChokiItem').value === true" appearance="outline"
            class="month-style input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[20%]">
            <mat-label>満了予定年月</mat-label>
            <input matInput formControlName="expScheduleMonth" autocomplete="off" maxlength="7" type="month" required>
          </mat-form-field>
          <mat-form-field *ngIf="item.get('dispChokiItem').value === true" appearance="outline"
            class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[20%]">
            <mat-label>付帯契約の継続年数</mat-label>
            <input matInput formControlName="continuYears" autocomplete="off" maxlength="2" class="number-style" required>
          </mat-form-field>
          <!-- 商品コード -->
          <input formControlName="ftGoodsCode" autocomplete="off" type="hidden" />
          <!-- 継続年数表示フラグ -->
          <input formControlName="dispChokiItem" autocomplete="off" type="hidden" />
        </div>
      </ng-container>
    </div>
  </div>

  <h2>契約書情報</h2>
  <div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
    <mat-form-field appearance="outline"
      class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
      <mat-label>契約締結日</mat-label>
      <input matInput [matDatepicker]="agreementDate" formControlName="agreementDate" autocomplete="off">
      <mat-datepicker-toggle matSuffix [for]="agreementDate"></mat-datepicker-toggle>
      <mat-datepicker #agreementDate></mat-datepicker>
    </mat-form-field>

    <mat-form-field appearance="outline"
      class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
      <mat-label>契約書受領日</mat-label>
      <input matInput [matDatepicker]="receiptDate" formControlName="receiptDate" autocomplete="off">
      <mat-datepicker-toggle matSuffix [for]="receiptDate"></mat-datepicker-toggle>
      <mat-datepicker #receiptDate></mat-datepicker>
    </mat-form-field>
  </div>

  <div *ngIf="dispPrdClsfyDiv === 'basiCtr'"
    class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
    <mat-form-field appearance="outline"
      class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
      <mat-label>基本契約締結日</mat-label>
      <input matInput [matDatepicker]="basicAgreementDate" formControlName="basicAgreementDate" autocomplete="off">
      <mat-datepicker-toggle matSuffix [for]="basicAgreementDate"></mat-datepicker-toggle>
      <mat-datepicker #basicAgreementDate></mat-datepicker>
    </mat-form-field>

    <mat-form-field appearance="outline"
      class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
      <mat-label>基本契約書受領日</mat-label>
      <input matInput [matDatepicker]="basicReceiptDate" formControlName="basicReceiptDate" autocomplete="off">
      <mat-datepicker-toggle matSuffix [for]="basicReceiptDate"></mat-datepicker-toggle>
      <mat-datepicker #basicReceiptDate></mat-datepicker>
    </mat-form-field>
  </div>

  <div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-end tw-items-center tw-content-center">
    <mat-card-actions class="btn_area_right">
      <button type="button" mat-raised-button color="primary" class="btn" (click)="onClickRegist()"
        [disabled]="parentForm.invalid || contModInputChildForm.invalid">
        修正
      </button>
    </mat-card-actions>

    <mat-card-actions class="btn_area_right">
      <button type="button" mat-raised-button color="primary" class="btn" (click)="onClickClose()">
        閉じる
      </button>
    </mat-card-actions>
  </div>